import { setConfiguration } from "@configuratorware/configurator-frontendgui/App/configuration";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import DesignDataService from "../Services/DesignDataService";
import VisualizationService from "../Services/VisualizationService";
import ConfiguratorService from "../Services/ConfiguratorService";
import ConfiguratorScreen from "./App/Screens/ConfiguratorScreen";
import CustomReducer from "./App/Shared/Reducer";
import groupReducer from "./App/Reducers/groupReducer";

const prod = process.env.NODE_ENV === "production";

const envDomains = {
  test: "http://configurator-dev.meinhalsband.de",
  int: "http://int.mein-halsband.local",
  local: "http://localhost:8080",
  prod: "",
};

const domain = envDomains[prod ? "prod" : "int"];

const query = new URLSearchParams(location.search);

const adminMode = query.get("_adminmode");

const customApplicationConfiguration = {
  showStartHere: true,
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}/`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
  },
  reducers: {
    configurator: CustomReducer,
    group: groupReducer,
  },
  services: {
    DesignDataService,
    VisualizationService,
    ConfiguratorService,
  },
  disableBeforeunloadWarning: true,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader("no-cache");
}

export default customApplicationConfiguration;
